import { FilterModel, FilterType, OperatorFilterEnum } from 'features/common/types';

export const PASSENGER_LIST_FIXED_FILTERS: Record<string, boolean> = { isPhysicalPerson: true };
export const CLIENT_LIST_FIXED_FILTERS: Record<string, boolean> = { invoiceable: true };

export type PassengersListVariant = 'passenger' | 'client';
export type PersonTypeTab = 'all' | 'physical' | 'legal';

export const QUICK_FILTER_KEYS = ['name', 'lastName', 'documentNumber'];

export const advancedListFilters: FilterModel[] = [
	{
		label: 'ID',
		type: FilterType.STRING,
		key: 'id',
		operator: OperatorFilterEnum.EQUALS,
	},
	{
		label: 'Nombre',
		type: FilterType.STRING,
		key: 'name',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Apellidos',
		type: FilterType.STRING,
		key: 'lastName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'País',
		type: FilterType.STRING,
		key: 'countryName',
		operator: OperatorFilterEnum.CONTAINS,
	},
	{
		label: 'Documento de facturación',
		type: FilterType.STRING,
		key: 'documentNumber',
		operator: OperatorFilterEnum.CONTAINS,
	},
];

export const PERSON_TYPE_TAB_URL_MAP: Record<PersonTypeTab, string | null> = {
	all: null,
	physical: 'fisica',
	legal: 'juridica',
};

export const personTypeFromUrl = (search: string): PersonTypeTab => {
	const tipo = new URLSearchParams(search).get('tipo');
	if (tipo === 'fisica') return 'physical';
	if (tipo === 'juridica') return 'legal';
	return 'all';
};
